import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const CardWidget: WidgetRegistryEntry = {
  name: "Card",
  configuration: () => import("./configuration").then((m) => m.CardWidgetConfiguration),
  component: () => import("./card-widget.component").then((m) => m.CardWidgetComponent)
};
